import styled from 'styled-components';

const sizePx = (size) => {
  if (size === 'small') return 28;
  if (size === 'large') return 48;
  return 36;
};

const fontSizePx = (size) => {
  if (size === 'small') return 10;
  if (size === 'large') return 16;
  return 12;
};

export const AvatarCircle = styled.div`
  width: ${(props) => sizePx(props.size)}px;
  height: ${(props) => sizePx(props.size)}px;
  border-radius: 8px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'linear-gradient(135deg, rgba(250, 70, 22, 0.14), rgba(250, 70, 22, 0.05))'
      : 'linear-gradient(135deg, rgba(250, 70, 22, 0.12), rgba(250, 70, 22, 0.04))'};
  border: 1px solid ${(props) => props.theme.colors.primaryOpacity(0.45)};
  color: ${(props) => props.theme.colors.primary};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${(props) => fontSizePx(props.size)}px;
  font-weight: 700;
  letter-spacing: 0.04em;
  flex-shrink: 0;
  text-transform: uppercase;
  user-select: none;
`;
